import { TextArea } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion } from '@neo.tax/shared';

import { QuestionProps } from './company-info.types';

export const TextareaField: React.FC<QuestionProps> = ({ question: { answerValue, id, placeholder, questionId } }) => {
  const updateCompanyQuestionAnswer = useUpdateCompanyQuestion(id, questionId);

  return (
    <TextArea
      onChange={(e): void => {
        updateCompanyQuestionAnswer({ answerValues: e.target.value });
      }}
      placeholder={placeholder ?? ''}
      type="text"
      value={answerValue ?? ''}
    />
  );
};
